export default {
  'validation:email-is-valid': 'Please enter a valid email address.',
  'validation:phone-is-valid': 'Your phone number does not seem to be correct.',
  'validation:required': 'Please fill in.',
  'validation:min-length-6': 'Please enter at least 6 characters.',
  'validation:min-length-12': 'Please enter at least 12 characters.',
  'validation:matches-password': 'The passwords do not match.',
  'validation:zip-is-valid': 'Invalid ZIP code',
  'validation:otp-must-be-x-digits': 'The code must be exactly {digits} digits.',
  'validation:otp-invalid-code': 'The entered code is invalid.',
  'validation:otp-too-many-attempts': 'Too many attempts. Please try again later.',
  'validation:otp-unknown-error': 'An error occurred. Please try again later.',
  'validation:otp-guest-not-allowed': 'Guest customers cannot use OTP login',
  'validation:unknown': 'An error occurred. Please try again later.',
  'validation:no-whitespace': 'Spaces are not allowed in the password.',
};
